export const acceptedHomeworkStatus = 4;

export const studentStatuses = {
  admin: 1,
  teacher: 2,
  assistant: 3,
  student: 4
};
